import { Dispatch } from "redux";
import { CourseSubtitleData } from "../../models/courseData";
import { courseSubtitleService } from "../../api/index";

import {
  COURSE_SUBTITLES_REQUEST,
  COURSE_SUBTITLES_SUCCESS,
  COURSE_SUBTITLES_FAILURE,
  CourseSubtitleActionTypes,
  CourseSubtitlesRequestAction,
  CourseSubtitlesFailureAction,
  CourseSubtitlesSuccessAction,
} from "./types";

/**
 * Async action to fetch course subtitles.
 *
 * Dispatches a request action, then attempts to fetch course subtitles from the API.
 * If successful, dispatches success action with data.
 * If failed, dispatches failure action.
 *
 * @returns A thunk action for Redux.
 */
export const getCourseSubtitles = () => {
  return async (dispatch: Dispatch<CourseSubtitleActionTypes>) => {
    dispatch(courseSubtitleRequest());
    courseSubtitleService
      .getCourseSubtitles()
      .then((response: CourseSubtitleData[]) => {
        dispatch(courseSubtitleSuccess(response));
      })
      .catch(() => {
        dispatch(courseSubtitleFailure());
      });
  };
};

/**
 * Action creator for successfully fetched course subtitles.
 *
 * @param data - Array of course subtitle objects.
 * @returns Action with type `COURSE_SUBTITLES_SUCCESS` and payload.
 */
export function courseSubtitleSuccess(
  data: CourseSubtitleData[]
): CourseSubtitlesSuccessAction {
  return {
    type: COURSE_SUBTITLES_SUCCESS,
    data,
  };
}

/**
 * Action creator for initiating the course subtitles request.
 *
 * @returns Action with type `COURSE_SUBTITLES_REQUEST`.
 */
export function courseSubtitleRequest(): CourseSubtitlesRequestAction {
  return {
    type: COURSE_SUBTITLES_REQUEST,
  };
}

/**
 * Action creator for failed course subtitles request.
 *
 * @returns Action with type `COURSE_SUBTITLES_FAILURE`.
 */
export function courseSubtitleFailure(): CourseSubtitlesFailureAction {
  return {
    type: COURSE_SUBTITLES_FAILURE,
  };
}
